// dataListModifier.js

export default {

    // Params:
    //  masterObj: The source data object with key / value pairs.
    //  extractedItemsArr: Optional. Array of values that should be a subset of keys of the masterObj. In the resulting
    //      array of tuples that's created, the tuples associated with each element of this array will be
    //      at the beginning of that array. The corresponding key/value pairs of the masterObj are "pulled" ('subtracted')
    //      from the masterObj.
    //  separatorTuple: Optional. A "key/value" pair reprenting what the separator between the two groups will be.
    //      Default: ['-','-----']
    //  positionFront: Boolean. If set to true, then extracted items appear at FRONT of resulting array; otherwise,
    //      they appear at the end of the resulting array.
    //  sortCallback: Optional. Sort function to use for sorting the two main groups of tuples (the top list and the remaining list).
    //      Default: Alpha ascending on the 2nd element of the tuple (i.e. would be on the 'values' of the masterObj, not the
    //          'keys' of the masterObj).
    //  prePendTuples: Optional. Tuples to appear at the beginning of the resulting list. Order of elements unchanged in result.
    //  postPendTuples: Optional. Tuples to appear at the end of the resulting list. Order of elements unchanged in result.
    // Returns:
    //  An array of tuples. The two main groups of tuples, i.e. the one representing the extractedItemsArr and the other
    //  representing the remainging key/value pairs in the  masterObj are sorted in alpha ascending order, by default.
    //  The array of tuples is ordered: prePendTuples, topItems, separator, remaining items (from masterObj), postPendTuples
    generateTwoGroupedList: (masterObj, extractedItemsArr, separatorTuple, positionFront, sortCallback, prePendTuples, postPendTuples) => {

        extractedItemsArr = extractedItemsArr || [];
        separatorTuple = separatorTuple || ['-', '-----'];

        // Make separatorTuple an alement of an array
        let separatorTupleArr = [separatorTuple];

        // If no extractedItemsArr, then separator element appears at beginning of result array.
        // So, if no extractedItemsArr, then have no separatorTupleArr
        if (!extractedItemsArr.length) {
            separatorTupleArr = [];
        }

        prePendTuples = prePendTuples || [];
        postPendTuples = postPendTuples || [];

        const defaultSortCallback = (a, b) => a[1] > b[1] ? 1 : -1;
        sortCallback = sortCallback || defaultSortCallback;

        const extractedItemsTuples = extractedItemsArr.
        map(i => [i, masterObj[i]]).
        sort(sortCallback);

        const remainingMasterTuples = Object.keys(masterObj).
        filter(i => !extractedItemsArr.includes(i)).
        map(i => [i, masterObj[i]]).
        sort(sortCallback);

        // Combine the arrays of tuples, putting top items in front, with dividing tuple between them
        let combinedTuples = [];
        if (positionFront) {
            combinedTuples = [...prePendTuples, ...extractedItemsTuples, ...separatorTupleArr, ...remainingMasterTuples, ...postPendTuples]
        } else {
            combinedTuples = [...prePendTuples, ...remainingMasterTuples, ...separatorTupleArr, ...extractedItemsTuples, ...postPendTuples]
        }

        return combinedTuples;

    }

}